/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { Alert, Snackbar, Typography } from '@mui/material'
import { BookingReference } from 'api/models/BookingReference.type'
import AccountInformation from 'components/Bookings/AccountInformation/AccountInformation'
import Confirmation from 'components/Bookings/Confirmation/Confirmation'
import JourneyPlan from 'components/Bookings/JourneyPlan/JourneyPlan'
import QQAccount from 'components/Bookings/QuickQuote/QQAccount'
import GroupedSupplierOptions from 'components/Bookings/TransportOptions/GroupedSuppliers/GroupedSupplierOptions'
import { WizardStep } from 'components/RouteWizard/RouteWizard'
import Wizard from 'components/RouteWizard/Wizard'
import useBookingById from 'hooks/useBookingById'
import useBookingJobs from 'hooks/useBookingJobs'
import useBookingReferences from 'hooks/useBookingReferences'
import { DateTime } from 'luxon'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import BaseLayout from '../../../layouts/Base/BaseLayout'
import {
  copyBooking,
  setCancelSuccess,
} from '../../../reducers/bookingsReducer'
import JourneyType from '../JourneyTypePage/JourneyType'

type BookingData = {
  type: any
  account: any
  plan: any
  transport: any
  preview: any
}

export default function WizardClassicPage() {
  const dispatch = useDispatch()
  const currentClient = useSelector((state: any) => state.clients.client)
  const copiedBooking = useSelector((state: any) => state.bookings.copyBooking)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | undefined>()
  const [initialBookingData, setInitialBookingData] = useState<
    BookingData | undefined
  >(undefined)
  const [spinner, setSpinner] = useState(copiedBooking === null ? false : true)
  const quickQuote = useSelector((state: any) => state.bookings.quickQuote)
  const cancelSuccess = useSelector(
    (state: any) => state.bookings.cancelSuccess,
  )

  const bookingToCopy = useBookingById(copiedBooking)
  const bookingJobs = useBookingJobs(copiedBooking)

  console.log('bookingToCopy', bookingToCopy)

  const { bookingReferences, isLoading: isBookingRefLoading } =
    useBookingReferences(bookingToCopy?.booking?.client.clientId)

  useEffect(() => {
    if (
      bookingToCopy?.booking !== null &&
      bookingToCopy?.booking !== undefined
    ) {
      setSpinner(true)
      var leadPassenger = bookingToCopy.booking.passengers.find(
        (x: any) => x.isLeadPassenger === true,
      )

      let bookingRefs = null
      if (bookingReferences && bookingReferences !== undefined) {
        bookingRefs = bookingReferences.map(function (
          element: BookingReference,
        ) {
          let existingRef = null
          if (bookingToCopy.booking.bookingReferenceValues) {
            existingRef = bookingToCopy.booking.bookingReferenceValues.find(
              (x: any) => x.bookingReferenceId == element.id,
            )
          }

          return {
            bookingReferenceId: element.id,
            isMandatory: element.isMandatory,
            regex: element.regex,
            value: existingRef?.value,
          }
        })
      }

      let passengers = null
      if (bookingToCopy.booking.passengers.length > 0) {
        passengers = bookingToCopy.booking.passengers.map(function (
          element: any,
        ) {
          if (element.isLeadPassenger) {
            return {}
          }

          return {
            userId: element.userId,
            name: element.name,
            isLeadPassenger: element.isLeadPassenger,
            contactNumber: element.contactNumber,
            email: element.email,
          }
        })
      }

      let services = null
      if (bookingJobs.jobs.value[0].services.length > 0) {
        services = 'MeetAndGreet'
      }

      let initialBooking = {
        type: bookingToCopy.booking.bookingTypeName.toLowerCase(),
        account: {
          accountType:
            bookingToCopy.booking.clientId !== currentClient.id ||
            bookingToCopy.booking.onBehalfOf
              ? 'other'
              : 'my',
          copyBookingFlag: true,
          clientId: bookingToCopy.booking.client.clientId,
          mainPassenger: {
            userId: leadPassenger.userId,
            name: leadPassenger.name,
            email: leadPassenger.email,
            contactNumber: leadPassenger.contactNumber,
            isLeadPassenger: true,
          },
          passengers: passengers ? [...passengers] : [],
          numberOfPassengers: bookingToCopy.booking.numberOfPassengers,
          onBehalfOf:
            bookingToCopy.booking.onBehalfOf.id === 0
              ? null
              : bookingToCopy.booking.onBehalfOf,
          bookingReferenceValues: bookingRefs ? [...bookingRefs] : [],
        },
        plan: {
          isImmediateJourney: bookingToCopy.booking.isImmediateJourney,
          journeyTypeName: bookingToCopy.booking.journeyTypeName,
          ...(bookingToCopy.booking.directedJourneyTime && {
            directedJourneyTime: bookingToCopy.booking.directedJourneyTime,
          }),
          outbound: {
            when: DateTime.fromISO(bookingToCopy.booking.when)
              .setZone(bookingToCopy.booking.timeZone)
              .toISO({ includeOffset: false }),
            pickup: bookingToCopy.booking.pickup,
            ...(services && { services }),
            ...(bookingToCopy.booking.dropOff.formattedAddress && {
              dropOff: bookingToCopy.booking.dropOff,
            }),
            timeZone: bookingToCopy.booking.timeZone,
            specialInstructions: bookingToCopy.booking.specialInstructions,
          },
          additionalStops: bookingToCopy.booking.additionalStops,
        },
        transport: {},
        preview: {},
      }
      setInitialBookingData(initialBooking)
      setSpinner(false)
    }
  }, [copiedBooking])

  const isdefaultJourney: WizardStep<BookingData>[] = !quickQuote
    ? [
        {
          component: JourneyPlan,
          path: '/plan',
          stepLabel: 'Journey Plan',
          selector: (data) => {
            if (data?.plan == null) {
              return data?.plan
            }

            const deserializeLeg = (leg: any) => {
              const ms = 1000 * 60 * 15

              const when =
                leg?.when != null
                  ? new Date(
                      Math.round(new Date(leg?.when)?.getTime() / ms) * ms,
                    )
                  : new Date(Math.round(new Date()?.getTime() / ms) * ms)

              return {
                ...leg,
                when,
              }
            }

            return {
              ...data?.plan,
              inbound: deserializeLeg(data?.plan?.inbound),
              outbound: deserializeLeg(data?.plan?.outbound),
            }
          },
          onSuccess: (data, formData) => {
            return {
              ...data,
              plan: formData.plan,
              preview: {
                ...data.preview,
                ...formData.preview,
              },
            }
          },
        },
      ]
    : []

  const additionalInformation: WizardStep<BookingData>[] = quickQuote
    ? [
        {
          component: QQAccount,
          path: '/account-information',
          stepLabel: 'Type',
          selector: (data) => data,
          onSuccess: (data, formData) => {
            return {
              ...data,
              transport: formData.transport,
              prices: formData.prices,
              preview: {
                ...data.preview,
                ...formData.preview,
              },
            }
          },
        },
      ]
    : []

  const steps: WizardStep<BookingData>[] = [
    {
      component: JourneyType,
      path: '/create',
      stepLabel: 'Type',
      selector: (data) => data?.type,
      onSuccess: (data, formData) => {
        return {
          ...data,
          type: formData,
        }
      },
    },
    {
      component: AccountInformation,
      path: '/account',
      stepLabel: 'Account Information',
      selector: (data: any) => {
        if (!quickQuote) {
          return data?.account
        }
        if (data?.plan == null) {
          return data?.plan
        }
        const deserializeLeg = (leg: any) => {
          const ms = 1000 * 60 * 15
          const when =
            leg?.when != null
              ? new Date(Math.round(new Date(leg?.when)?.getTime() / ms) * ms)
              : new Date(Math.round(new Date()?.getTime() / ms) * ms)
          return {
            ...leg,
            when,
          }
        }
        return {
          ...data?.plan,
          ...data?.account,
          inbound: deserializeLeg(data?.plan?.inbound),
          outbound: deserializeLeg(data?.plan?.outbound),
        }
      },
      onSuccess: (data, formData) => {
        const includePlan = quickQuote ? { plan: formData?.plan } : {}
        return {
          ...data,
          ...includePlan,
          account: formData.account,
          preview: { ...formData.preview },
        }
      },
    },
    ...isdefaultJourney,
    {
      component: GroupedSupplierOptions,
      path: '/transport',
      stepLabel: 'Transport Options',
      selector: (data) => data?.transport,
      onSuccess: (data, formData) => {
        return {
          ...data,
          transport: formData.transport,
          prices: formData.prices,
          preview: {
            ...data.preview,
            ...formData.preview,
          },
        }
      },
    },
    ...additionalInformation,
    {
      component: Confirmation,
      path: '/confirmation',
      stepLabel: 'Confirmation',
      selector: (data) => data,
      showLeaveWarning: false,
    },
  ]

  useEffect(() => {
    if (spinner) {
      setTimeout(() => {
        setSpinner(false)
      }, 1000)
    }
  }, [])

  useEffect(() => {
    let ti: string | number | NodeJS.Timeout | undefined
    if (cancelSuccess) {
      ti = setTimeout(() => {
        dispatch(setCancelSuccess(false))
      }, 3000)
    }
    return () => {
      clearTimeout(ti)
    }
  }, [cancelSuccess])

  return (
    <>
      <BaseLayout
        pageTitle={quickQuote ? 'Quick Quote' : 'Create new booking'}
        pageSubtitle="Complete the information and we'll quote your travel"
        mainElement={
          <>
            {spinner && (
              <>
                <Typography
                  variant="h4"
                  textAlign={'center'}
                  sx={{ paddingTop: '30px' }}
                >
                  Copying Booking
                </Typography>
                <Typography variant="body1" textAlign={'center'}>
                  Booking journey will start shortly
                </Typography>
              </>
            )}
            {!spinner && (
              <Wizard
                loading={loading}
                error={error}
                steps={steps}
                basePath={'admin/bookings/create'}
                initialData={initialBookingData}
                onClearWizard={() => dispatch(copyBooking(null))}
              />
            )}
          </>
        }
      ></BaseLayout>
      <Snackbar open={cancelSuccess} autoHideDuration={3000}>
        <Alert severity="success">Booking is successfully cancelled</Alert>
      </Snackbar>
    </>
  )
}
